export class ChangeMobileRequest {
    ekpay_id: string;
    mobile: string;
}


// WEBPACK FOOTER //
// ./src/app/user/change-mobile/change-mobile.ts